<app-page-body>

  <!-- header -->
  <app-page-header [title]="title|translate" [isForm]="true" (onBack)="onClose()" [showRefreshBtn]="false">
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">

    <div class="row ">

      <!--first column-->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-px-1">


        <!-- userId -->
        <div class="tw-mb-4">
          <list-group-item [label]="'common.userId'|translate" [value]="model?.document?.userInfo?.userId|checkValue">
          </list-group-item>
        </div>

        <!-- userName -->
        <div class="tw-mb-4">
          <list-group-item [label]="'common.userName'|translate"
            [value]="model?.document?.userInfo?.userName|checkValue">
          </list-group-item>
        </div>

        <!-- remoteIpAddress -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'remoteIpAddress'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddress|ipDisplayer)|checkValue">
          </list-group-item>
        </div>

        <!-- localIpAddress -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'localIpAddress'|translate"
            [value]="(model?.document?.userInfo?.localIpAddress|ipDisplayer)|checkValue">
          </list-group-item>
        </div>

        <!--applicationName-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'applicationName'|translate"
            [value]="(model?.document?.userInfo?.applicationName)|checkValue">
          </list-group-item>
        </div>


        <!--ip-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'ip'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.ip)|checkValue">
          </list-group-item>
        </div>

        <!--timezone-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'timezone'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.geo?.timezone)|checkValue">
          </list-group-item>
        </div>

        <!--className -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'className'|translate" [value]="data?.className|checkValue">
          </list-group-item>
        </div>

      </div>

      <!--second column-->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-px-1">
        <!--continent_code-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'continent_code'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.geo?.continent_code)|checkValue ">
          </list-group-item>
        </div>


        <!--country_name-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'country_name'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.geo?.country_name)|checkValue">
          </list-group-item>
        </div>


        <!--country_iso_code-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'country_iso_code'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.geo?.country_iso_code)|checkValue">
          </list-group-item>
        </div>

        <!--lon-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'lon'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.geo?.location?.lon)|checkValue">
          </list-group-item>
        </div>

        <!--lat-->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'lat'|translate"
            [value]="(model?.document?.userInfo?.remoteIpAddressGeo?.geo?.location?.lat)|checkValue">
          </list-group-item>
        </div>

        <!-- name -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'clientUserAgent.name'|translate"
            [value]="model?.document?.userInfo?.clientUserAgent?.name|checkValue">
          </list-group-item>
        </div>

        <!-- version -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'clientUserAgent.version'|translate"
            [value]="model?.document?.userInfo?.clientUserAgent?.version|checkValue">
          </list-group-item>
        </div>


      </div>

      <!--third column-->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-px-1">
        <!-- os name -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'os.name'|translate"
            [value]="model?.document?.userInfo?.clientUserAgent?.os?.name|checkValue">
          </list-group-item>
        </div>

        <!--device name -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'device.name'|translate"
            [value]="model?.document?.userInfo?.clientUserAgent?.device?.name|checkValue">
          </list-group-item>
        </div>

        <!-- os full -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'os.full'|translate"
            [value]="model?.document?.userInfo?.clientUserAgent?.os?.full|checkValue">
          </list-group-item>
        </div>

        <!-- os version -->
        <div class="tw-mb-4">
          <list-group-item [label]="fields+'os.version'|translate"
            [value]="model?.document?.userInfo?.clientUserAgent?.os?.version|checkValue">
          </list-group-item>
        </div>

        <!-- type -->
        <div class="tw-mb-4">
          <list-group-item [label]="'common.type'|translate" [value]="model?.document?.target?.Type|checkValue ">
          </list-group-item>
        </div>

        <!-- startDate -->
        <div class="tw-mb-4">
          <list-group-item [label]="'common.startDate'|translate" [isShowValue]="false">
            <div class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap" content>
              <span class="dir-ltr">
                {{model?.document?.startDate|dateTimeConvertor:translationService.currentLang()||'fa'}}
              </span>
            </div>
          </list-group-item>
        </div>

        <!-- endDate -->
        <div class="tw-mb-4">
          <list-group-item [label]="'common.endDate'|translate" [isShowValue]="false">
            <div class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap" content>
              <span class="dir-ltr">
                {{model?.document?.endDate|dateTimeConvertor:translationService.currentLang()||'fa'}}
              </span>
            </div>
          </list-group-item>
        </div>

      </div>


      <!--message -->
      <div class="md:tw-w-full tw-px-1">
        <list-group-item [label]="fields+'comments'|translate" [value]="data?.message|checkValue">
        </list-group-item>
      </div>

      <!--detail -->
      <div class="md:tw-w-full tw-px-1">
        <list-group-item direction="ltr" [label]="'common.detail'|translate" [value]="data?.detail|checkValue">
        </list-group-item>
      </div>

      <!--userAgent-->
      <div class="md:tw-w-full tw-px-1">
        <list-group-item [label]="fields+'userAgent'|translate"
          [value]="(model?.document?.userInfo?.userAgent)|checkValue">
        </list-group-item>
      </div>




    </div>


  </div>

</app-page-body>
